import jsCookie from 'js-cookie'
import { toLogin } from './login-helper'

class LocationClazz {
  public getHostName(url: string) {
    const match = url.match(/:\/\/(www[0-9]?\.)?(.[^/:]+)/i)
    if (
      match != null &&
      match.length > 2 &&
      typeof match[2] === 'string' &&
      match[2].length > 0
    ) {
      return match[2]
    } else {
      return null
    }
  }
  public getDomain(url: string) {
    const hostName = this.getHostName(url)
    let domain = hostName

    if (hostName != null) {
      const parts = hostName.split('.').reverse()

      if (parts != null && parts.length > 1) {
        domain = parts[1] + '.' + parts[0]

        if (
          hostName.toLowerCase().indexOf('.co.uk') != -1 &&
          parts.length > 2
        ) {
          domain = parts[2] + '.' + domain
        }
      }
    }

    return domain
  }
}

const loc = new LocationClazz()

const newJc: any = function () {
  // empty
}

for (const [key, value] of Object.entries(jsCookie)) {
  if (key === 'set') {
    const newVal = (...args: any) => {
      const domain = loc.getDomain(location.href)
      if (!args[2]) {
        args[2] = { domain, expires: 1 } // cookie默认设置1天
      } else if (args[2]) {
        args[2].domain = args[2].domain || domain
        args[2].expires = args[2].expires || 1
      }
      value(...args)
    }
    newJc[key] = newVal
  } else if (key === 'remove') {
    const newVal = (...args: any) => {
      const domain = loc.getDomain(location.href)
      if (!args[1]) {
        args[1] = { domain }
      } else if (args[1] && !args[1].domain) {
        args[1].domain = domain
      }
      value(...args)
    }
    newJc[key] = newVal
  } else {
    newJc[key] = value
  }
}

export const cookies = newJc

export const clearAllCookies = function () {
  Object.keys(cookies.get()).forEach(function (cookieName) {
    cookies.remove(cookieName)
  })
}

export function getDevice(): string {
  const ua = navigator.userAgent
  const src = cookies.get('source')
  if (src === 'ios') {
    return 'ios'
  } else if (src === 'android') {
    return 'android'
  } else if (/MicroMessenger/i.test(ua)) {
    return 'weixin'
  } else if (/Mobile/i.test(ua)) {
    return 'mobile'
  }
  return 'other'
}

export function isAndroidApp(): boolean {
  return getDevice() === 'android'
}

export function isIosApp(): boolean {
  return getDevice() === 'ios'
}

export function isApp(): boolean {
  return isIosApp() || isAndroidApp()
}

export function isWeixin(): boolean {
  return getDevice() === 'weixin'
}

export function isRkhy(): boolean {
  const source = cookies.get('source')
  const apptype = cookies.get('apptype')
  return (source === 'android' || source === 'ios') && apptype === 'rkhy'
}

export function isHzwApp(): boolean {
  // app特指孩子王app，不包括人客合一
  const source = cookies.get('source')
  const appcode = cookies.get('appcode')
  return (source === 'android' || source === 'ios') && appcode === 'HZWMALL'
}

export function isLogin(): boolean {
  const uid = cookies.get('uid')
  const skey = cookies.get('skey')
  return uid && skey
}

export const uid = cookies.get('uid') || ''
export const skey = cookies.get('skey') || ''
export const guid = cookies.get('guid') || ''
export const empId = cookies.get('empId') || ''

export function isSelf(id?: string): boolean {
  return id == empId
}

export async function ensureLogin(url?: string) {
  const uid = cookies.get('uid')
  const skey = cookies.get('skey')
  if (uid && skey) {
    return {
      uid,
      skey
    }
  }
  toLogin(url)
  throw {}
}
